module.exports = __webpack_public_path__ + "static/media/icon-import.e35431ed.svg";